<script setup lang="ts">
import type { ICustomField } from '@nova/core';
import CustomFieldLabel from './CustomFieldLabel.vue';

/**
 * Base wrapper component for all custom field inputs.
 * Provides consistent layout with optional icon and label.
 *
 * Used by all field type components to ensure uniform structure.
 */
interface CustomFieldInputBaseProps {
  field: ICustomField;
  fieldIcon?: string;
  displayLabel?: boolean;
  required?: boolean;
}

const {
  field,
  fieldIcon = '',
  displayLabel = true,
  required = false
} = defineProps<CustomFieldInputBaseProps>();
</script>

<template>
  <div class="d-flex flex-column ga-2 w-100">
    <v-icon v-if="fieldIcon" class="align-self-start">
      {{ fieldIcon }}
    </v-icon>

    <custom-field-label v-if="displayLabel && field?.label" :field="field" />

    <slot />
  </div>
</template>

<style scoped lang="scss">
:deep(.v-input) {
  margin-top: 0 !important;
  padding-top: 0 !important ;
}
</style>
